import map from 'lodash/map';

export function transformHearings(hearings) {
  return map(hearings, ({ display_title, url }) => ({
    value: display_title,
    href: url,
    isExternal: true,
  }));
}
